import FmdGoodIcon from '@mui/icons-material/FmdGoodOutlined';

const MaterialFmdGoodIcon = (props) => {
  return <FmdGoodIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialFmdGoodIcon;
